var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "justify-content": "space-between" } },
    [
      _c("el-input", {
        staticStyle: { width: "60px", "margin-right": "5px" },
        attrs: { value: _vm.defaultValue, disabled: true }
      }),
      _c(
        "cargo-advance-select",
        _vm._g(
          _vm._b(
            {
              staticStyle: { flex: "1" },
              attrs: {
                "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                "default-value": _vm.defaultValue
              }
            },
            "cargo-advance-select",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }